import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { sdk } from '@/services';

const PlanificationService = sdk.getService('PlanificationService');

const MIN_DAILY_STUDY_TIME = 30 * 60;
const MAX_DAILY_STUDY_TIME = 8 * 60 * 60;

export const usePlanificationByStudentId = (userId: string) => {
  const { isLoading, data, error } = useQuery({
    queryKey: ['planification', userId],
    queryFn: () => PlanificationService.getPlanificationByUser(userId!),
    enabled: !!userId
  });

  const dailyStudyTime = useMemo(() => data?.dailyStudyTime ?? 0, [data]);

  return {
    planification: data,
    isMaxTimeExceeded: dailyStudyTime > MAX_DAILY_STUDY_TIME,
    isLessThanMinTime: dailyStudyTime < MIN_DAILY_STUDY_TIME,
    isCorrectTime:
      data?.studyHours !== undefined
        ? true
        : dailyStudyTime >= MIN_DAILY_STUDY_TIME && dailyStudyTime <= MAX_DAILY_STUDY_TIME,
    isLoading,
    error
  };
};
